module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.isActive('/')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("主页")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/product')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/product"
    }
  }, [_vm._v("软件产品")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/dtability')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dtability"
    }
  }, [_vm._v("研发能力")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/solutions')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/solutions"
    }
  }, [_vm._v("解决方案")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/about')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1)])])])])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "logo-area"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-area section-padding footer-area-color"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row-foot"
  }, [_c('div', [_c('div', [_c('ul', [_c('li', [_vm._v("宜昌市艾福斯信息咨询有限责任公司")]), _vm._v(" "), _c('li', [_vm._v("\n                  宜昌高新区城东大道18-2-420号福海花园\n                   电话：0717-6331139\n                ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.88)"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("鄂ICP备2023004624号")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    staticStyle: {
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "rgba(255, 255, 255, 0.88)"
    },
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42050202000791"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "auto",
      "margin-bottom": "4px"
    },
    attrs: {
      "src": require("../static/assets/images/polic-log.png")
    }
  }), _vm._v("鄂公网安备 42050202000791号")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18969a06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 29
// module chunks = 0